export class SelectorDialogViewModel
{
    opened: boolean = false;

    workspaceId: number | null = null;
    portfolioId: string | null = null;
    scenarioId: string | null = null;

    show(workspaceId: number, portfolioId: string, scenarioId: string)
    {
        this.workspaceId = workspaceId;
        this.portfolioId = portfolioId;
        this.scenarioId = scenarioId;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
    }
}
